export const GRANT_TYPE_PASSWORD = 'password';
export const GRANT_TYPE_REFRESH = 'refresh_token';
export const CLIENT_ID = 'gera-dovana-reservations-web';
